import request from '@/utils/request'

let Product_cpaApi = {

  /*产品与库存列表*/
  list(data) {
    return request._post('/shop/plus.product_cpa.Index/index', data);
},
getCategory(data){
     return request._post('/shop/plus.product_cpa.Index/getCategory', data);
},
/*添加产品与库存*/
add(data) {
    return request._post('/shop/plus.product_cpa.Index/add', data);
},
audit(data) {
    return request._post('/shop/plus.product_cpa.Index/audit', data);
},
/*修改产品与库存*/
edit(data) {
    return request._post('/shop/plus.product_cpa.Index/edit', data);
},
setStatus(data) {
    return request._post('/shop/plus.product_cpa.Index/setStatus', data);
},
/*删除产品与库存*/
del(data) {
    return request._post('/shop/plus.product_cpa.Index/del', data);
},
/*产品与库存详情*/
detail(data) {
  return request._post('/shop/plus.product_cpa.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.product_cpa.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.product_cpa.Setting/getSetting', data, errorback);
    },
}
export default Product_cpaApi;



// WEBPACK FOOTER //
// ./src/api/product_cpa.js